<div class="chart_component" v-if="chartIds.length > 0">
    <div class="dialog" :class="{hiden_dialog: !chartIds.length > 0}">
        <div class="dialog_background" @click="$emit('closechart')"></div>
        <div class="dialog_container chart_container">
            <div class="dialog_content">
                <div class="dialog_header">
                    <div class="dialog_title">{{chartCode}}{{chartAttr == '' ? '': '-' + chartAttr + '-'}}{{ $t('salesDetail') }}</div>
                    <div class="dialog_close" @click="$emit('closechart')">
                        <div class="mdc-icon-button material-icons">close</div>
                    </div>
                </div>
                <div class="chart_sales_statistics">
                    <div class="chart_sales_title">{{ $t('salesStatistics') }}</div>
                    <div class="chart_sales_date_range">
                        <div class="date_pinker_range">
                            <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
                                <input id="chart_line_start_picker_input" type="text" aria-label="Date" />
                                <span class="tui-ico-date"></span>
                                <div id="chart_line_start_picker_container"></div>
                            </div>
                            <span>-</span>
                            <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
                                <input id="chart_line_end_picker_input" type="text" aria-label="Date" />
                                <span class="tui-ico-date"></span>
                                <div id="chart_line_end_picker_container"></div>
                            </div>
                        </div>
                        <div class="btn_g">
                            <div class="btn_g_b" :style="statisticsByDay?'background: #EB004E;color: #fff;': ''" @click="switchStatistics('day')">
                                {{ $t('statisticsByDay') }}
                            </div>
                            <div class="btn_g_b" :style="statisticsByWeek?'background: #EB004E;color: #fff;': ''" @click="switchStatistics('week')">
                                {{ $t('statisticsByWeek') }}
                            </div>
                            <div class="btn_g_b" :style="statisticsByMonth?'background: #EB004E;color: #fff;': ''" @click="switchStatistics('month')">
                                {{ $t('statisticsByMonth') }}
                            </div>
                        </div>
                    </div>
                    <div class="chart_view" id="chart_line_view"><canvas id="chart_line" width="1004" height="210"></canvas></div>
                </div>
                <div class="chart_sales_statistics">
                    <div class="chart_sales_title">{{ $t('salesComparison') }}</div>
                    <div class="chart_sales_date_range">
                        <div class="date_pinker_range">
                            <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
                                <input id="chart_bar_start_picker_input" type="text" aria-label="Date" />
                                <span class="tui-ico-date"></span>
                                <div id="chart_bar_start_picker_container"></div>
                            </div>
                            <span>-</span>
                            <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
                                <input id="chart_bar_end_picker_input" type="text" aria-label="Date" />
                                <span class="tui-ico-date"></span>
                                <div id="chart_bar_end_picker_container"></div>
                            </div>
                        </div>
                    </div>
                    <div class="chart_view" id="chart_bar_view"><canvas id="chart_bar" width="1004"
                            height="210"></canvas></div>
                </div>
            </div>
        </div>
    </div>
</div>